// import {qs} from '../qs'

import {qs} from '../qs'

const BASE_PATH = '/report'

const queryToPath = query => Object.values(query).join('/')

export default {
  getReportDetail: query => ({
    url: `${BASE_PATH}/data/${queryToPath(query)}`,
    method: 'GET'
  }),
  getReport: query => ({
    url: `${BASE_PATH}/${queryToPath(query)}`,
    method: 'GET'
  }),
  createReport: query => ({
    url: `${BASE_PATH}/${queryToPath(query)}`,
    // url: `${BASE_PATH}/daily?date=${encodeURIComponent(query.date)}`,
    method: 'POST'
  }),
  saveReport: (query, content) => ({
    url: `${BASE_PATH}/${queryToPath(query)}`,
    method: 'PUT',
    data: {
      content
    }
  }),
  exportReport: query => ({
    url: `${BASE_PATH}/export/${queryToPath(query)}`,
    method: 'GET'
  }),
  getPollutionProcessReports: query => ({
    url: `${BASE_PATH}/pollution/list${qs(query, '?')}`,
    method: 'GET'
  }),
  checkPollution: query => ({
    url: `${BASE_PATH}/pollution/check${qs(query, '?')}`,
    method: 'POST'
  }),
  createPollutionProcessReport: query => ({
    url: `${BASE_PATH}/pollution${qs(query, '?')}`,
    method: 'POST'
  }),
  getPollutionProcessReport: id => ({
    url: `${BASE_PATH}/pollution/${id}`,
    method: 'GET'
  }),
  savePollutionProcessReport: (id, content) => ({
    url: `${BASE_PATH}/pollution/${id}`,
    method: 'PUT',
    data: {
      content
    }
  }),
  exportPollutionProcessReport: id => ({
    url: `${BASE_PATH}/pollution/export/${id}`,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/WordReport.js